/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MeasuringPointOverview } from "./MeasuringPointOverview";
import {
  MeasuringPointOverviewFromJSON,
  MeasuringPointOverviewFromJSONTyped,
  MeasuringPointOverviewToJSON,
  MeasuringPointOverviewToJSONTyped,
} from "./MeasuringPointOverview";

/**
 *
 * @export
 * @interface GMNOverview
 */
export interface GMNOverview {
  /**
   *
   * @type {string}
   * @memberof GMNOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GMNOverview
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GMNOverview
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMNOverview
   */
  qualityRegime?: string | null;
  /**
   *
   * @type {Array<MeasuringPointOverview>}
   * @memberof GMNOverview
   */
  readonly measuringPoints?: Array<MeasuringPointOverview>;
}

/**
 * Check if a given object implements the GMNOverview interface.
 */
export function instanceOfGMNOverview(value: object): value is GMNOverview {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  return true;
}

export function GMNOverviewFromJSON(json: any): GMNOverview {
  return GMNOverviewFromJSONTyped(json, false);
}

export function GMNOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GMNOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    qualityRegime:
      json["quality_regime"] === undefined
        ? undefined
        : json["quality_regime"] === null
        ? null
        : json["quality_regime"],
    measuringPoints:
      json["measuring_points"] == null
        ? undefined
        : (json["measuring_points"] as Array<any>).map(MeasuringPointOverviewFromJSON),
  };
}

export function GMNOverviewToJSON(json: any): GMNOverview {
  return GMNOverviewToJSONTyped(json, false);
}

export function GMNOverviewToJSONTyped(
  value?: Omit<GMNOverview, "uuid" | "measuring_points"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    name: value["name"],
    quality_regime: value["qualityRegime"],
  };
}
